module.exports = __webpack_public_path__ + "media/fonts/Oricons-b188d410a9edf8e9ff1623e142de55c7.svg";